import { Grid } from '@mui/material';
import React, { useRef, useState } from 'react';
import useFrameworkTranslation from 'framework/language/useFrameworkTranslation';
import AryNotSelectablePinnedTable from './AryNotSelectablePinnedTable';
import AryTable from './AryTable';

const AryNotSelectableTable = ({
  data,
  columns,
  filteredColumnsList,
  pinnedColumnsList,
  noContentBox,
  customNoContent,
  isFlat,
  page,
  pageCount,
  tableSx,
  isLoading,
  skeletonSettings,
  onHover,
  rowBackgroundCondition,
  selectedTransactions
}) => {
  const { t } = useFrameworkTranslation();
  const langDirection = t('dir');
  const tableRef = useRef(null);
  const stickyHeadSx = {
    position: 'sticky',
    top: 0,
    backgroundColor: '#FFF',
    zIndex: 1
  };
  const [clickedRowIndex, setClickedRowIndex] = useState();
  return (
    <Grid
      container
      style={{
        flexDirection: langDirection === 'rtl' ? 'row-reverse' : 'row',
        height: '100%',
        overflowX: 'auto'
      }}
    >
      <Grid
        item
        flexGrow={1}
        sx={{
          display: filteredColumnsList.length ? null : 'none'
        }}
      >
        <AryTable
          ref={tableRef}
          data={data}
          columns={columns}
          filteredColumnsList={filteredColumnsList}
          noContentBox={noContentBox}
          customNoContent={customNoContent}
          isFlat={isFlat}
          page={page}
          pageCount={pageCount}
          rowBackgroundCondition={rowBackgroundCondition}
          selectedTransactions={selectedTransactions}
          tableSx={tableSx}
          onHover={onHover}
          defaultTableSelection="true"
          isLoading={isLoading}
          skeletonSettings={skeletonSettings}
        />
      </Grid>
      {pinnedColumnsList !== undefined && pinnedColumnsList.length > 0 && (
        <Grid item flexGrow={1}>
          <AryNotSelectablePinnedTable
            pinnedColumnsList={pinnedColumnsList}
            noContentBox={noContentBox}
            customNoContent={customNoContent}
            data={data}
            columns={columns}
            tableSx={tableSx}
            stickyHeadSx={stickyHeadSx}
            onHover={onHover}
            isFlat={isFlat}
            page={Number(page)}
            pageCount={Number(pageCount)}
            clickedRowIndex={clickedRowIndex}
            setClickedRowIndex={setClickedRowIndex}
            tableRef={tableRef}
          />
        </Grid>
      )}
    </Grid>
  );
};
export default AryNotSelectableTable;
